import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { RChip } from './RChip';
import { RTitle } from './RTitle';

interface RSectionHeaderProps {
    title: string;
    count?: number;
}

export function RSectionHeader({ title, count }: RSectionHeaderProps) {
    return (
        <Header>
            <RTitle size="h2">{title}</RTitle>
            {count !== undefined && (
                <RChip variant="filled" bgColor={Colors.turquoise}>
                    {count}
                </RChip>
            )}
        </Header>
    );
}

const Header = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 14,
});
